import { render, staticRenderFns } from "./EmergencyNumberModal.vue?vue&type=template&id=27515108&scoped=true&"
import script from "./EmergencyNumberModal.vue?vue&type=script&lang=js&"
export * from "./EmergencyNumberModal.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyNumberModal.vue?vue&type=style&index=0&id=27515108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27515108",
  null
  
)

export default component.exports